import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=0dcfb564&scoped=true&"
import script from "@/scripts/AI/index.js?vue&type=script&lang=js&"
export * from "@/scripts/AI/index.js?vue&type=script&lang=js&"
import style0 from "./AI.vue?vue&type=style&index=0&id=0dcfb564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcfb564",
  null
  
)

export default component.exports